const listeners = {};

export const getListeners = () => listeners;
export const getHiglightedText = () => {
  console.log('get highlighted text');
  window.parent.postMessage({
    message: 'NOOS_GET_HIGHLIGHTED_TEXT',
  }, '*');
};

export const registerEventListener = (name, callback) => {
  if (!Array.isArray(listeners[name])) {
    listeners[name] = [];
  }
  listeners[name].push(callback);
};

export const handleEvent = (e) => {
  if (listeners[e.data.eventName] !== undefined) {
    if (e.data.value) {
      listeners[e.data.eventName].forEach(currentListener => currentListener(e.data.value));
    }
  }
};

/* istanbul ignore next */
window.addEventListener('message', e => handleEvent(e));
